import React, { useContext } from 'react';
import { makeAutoObservable } from 'mobx';

import { ModelValidator } from 'framework/mobx-integration';

export type FormLabelPosition = 'floating' | 'left' | 'inside' | 'none';

export type FormAppearance = 'classic' | 'compact';

export type FormSettings<TModel extends object = object> = Partial<
	Pick<FormStore<TModel>, 'model' | 'validator' | 'appearance' | 'labelPosition' | 'labelWidth'>
>;

export class FormStore<TModel extends object = object> {
	model?: TModel;
	validator?: ModelValidator<TModel>;
	appearance: FormAppearance = 'classic';
	labelPosition: FormLabelPosition = 'floating';
	labelWidth = 65;

	constructor(settings: FormSettings<TModel> = {}) {
		this.update(settings);

		makeAutoObservable(this);
	}

	update(settings: FormSettings<TModel>) {
		Object.assign(this, Object.fromEntries(Object.entries(settings).filter(([, value]) => value !== undefined)));
	}
}

export const FormContext = React.createContext<FormStore>(null);

const applicationForm = new FormStore();

export function useFormStore() {
	return useContext(FormContext) ?? applicationForm;
}
